
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import ExhibitionList from './ExhibitionList';
import ExhibitionModal from './ExhibitionModal';
import { Exhibition } from './types';

const ExhibitionContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Exhibition | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const handleOpenAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (item: Exhibition) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setRefreshTrigger(prev => !prev); 
  };

  return (
    <>
      <Breadcrumbs mainTitle="Exhibitions" parent="Exhibitions" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitionList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refresh={refreshTrigger}
            />
          </Col>
        </Row>
        <ExhibitionModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />
      </Container>
    </>
  );
};

export default ExhibitionContainer;
